import * as yup from "yup";

const schema = yup.object().shape({
  channelname: yup
    .string()
    .min(3, "Minimum 3 characters")
    .required("Name is required"),
  channelkey: yup
    .string()
    .min(3, "Minimum 3 characters")
    .required("Key is required"),
  channelintegrationid: yup
    .number()
    .transform((cv, ov) => {
      return ov === "" ? undefined : cv;
    })
    .typeError("Integration Id must be a number"),
  channelskill: yup.string().required("Skill is required"),
  channelchannel: yup.string().required("Channel is required"),
  channelinfo: yup.string(),
  channeltimeout: yup
    .number()
    .transform((cv, ov) => {
      return ov === "" ? undefined : cv;
    })
    .typeError("Timeout must be a number")
    .min(1, "Minimum 1")
    .max(1440, "Maximum 1440"),
});

export default schema;
